/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpVaultConfig {
  /**
  * The name of the bucket
  */
  'bucketName'?: string;
  /**
  * The prefix of the bucket.
  */
  'bucketPrefix'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucketName",
      "baseName": "bucketName",
      "type": "string",
      "format": ""
    },
    {
      "name": "bucketPrefix",
      "baseName": "bucketPrefix",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVaultConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

